import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { ImageInfoRendererModule } from '../image-info-renderer/image-info-renderer.module';

import { KYMW1407SearchResultComponent } from './kymw1407-search-result.component';
import { KYMW1407Model } from '../kymw1407.model';


/**
 * 検索結果リスト モジュール設定クラス
 *
 * @export KYMW1407SearchResultModule
 * @class KYMW1407SearchResultModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    ImageInfoRendererModule,
  ],
  declarations: [
    KYMW1407SearchResultComponent,
  ],
  providers: [
    KYMW1407Model,
  ],
  exports: [
    KYMW1407SearchResultComponent,
  ]
})
export class KYMW1407SearchResultModule {
}
